import { render, staticRenderFns } from "./AvisosView.vue?vue&type=template&id=cfb3e7d4&"
import script from "./AvisosView.vue?vue&type=script&lang=ts&"
export * from "./AvisosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports